<!-- 问题处置详情 -->
<template>
  <div class="problem-details">
    <div class="detail-container">
      <!-- {{ detailData }} -->
      <div class="detail-item">
        <span class="flex-1">问题名称:</span>
        <span class="flex-2">{{ detailData.problemName || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="flex-1">问题类型:</span>
        <span class="flex-2">{{ detailData.problemSubtypeStr || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="flex-1">问题来源:</span>
        <span class="flex-2">{{ detailData.problemTypeStr || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="flex-1">上报人:</span>
        <span class="flex-2">{{ detailData.createUser || '' }}</span>
      </div>
      <div class="detail-item">
        <span class="flex-1">上报时间:</span>
        <span class="flex-2">{{ detailData.reportTimeStr || '' }}</span>
      </div>
      <div v-if="detailData.river" class="detail-item">
        <span v-if="detailData.river" class="flex-1">流域河段:</span>
        <span v-if="detailData.river" class="flex-2">{{ detailData.river || '' }}</span>
      </div>
      <div class="detail-item">
        <span class="flex-1">任务地址:</span>
        <span class="flex-2">{{ detailData.address || '' }}</span>
      </div>
      <div class="detail-item">
        <span class="flex-1">任务描述:</span>
        <span class="flex-2">{{ detailData.description || '' }}</span>
      </div>
      <n-divider />
      <div v-show="detailData.monitorDataDto">
        <SssjChart ref="sjChart"></SssjChart>
      </div>
    </div>
    <div class="detail-container">
      <div v-if="imageList.length > 0" style="">
        <p>现场照片:</p>
        <n-image v-for="image in imageList" :key="image.filePath" :src="image.filePath" />
      </div>
      <div v-if="videoList.length > 0">
        <p>现场视频:</p>
        <div>
          <video
            v-for="video in videoList"
            :key="video.filePath"
            width="300px"
            controls="{true}"
            :src="video.filePath"
          />
        </div>
      </div>
      <div v-if="audioList.length > 0">
        <p>现场录音:</p>
        <div>
          <audio
            v-for="audio in audioList"
            :key="audio.filePath"
            width="300px"
            controls="{true}"
            :src="audio.filePath"
          />
        </div>
      </div>
      <div v-if="docList.length > 0">
        <p>其他附件:</p>
        <div>
          <a v-for="doc in docList" :key="doc.filePath" style="margin: 0 20px" :href="doc.filePath">
            {{ doc.fileName }}
          </a>
        </div>
      </div>
    </div>
    <n-divider />
    <div class="detail-container">
      <p>处理流程</p>
      <work-flow ref="workFlow" @freshData="fresh"></work-flow>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
// import { wgyWtInfoUsingGET_1 } from '@/api/api';
import WorkFlow from '../WorkFlow.vue'
import SssjChart from '../charts/SssjChart.vue'
import { Api } from '@/api/publicApi'
const api = new Api()

export default {
  components: {
    WorkFlow,
    SssjChart,
  },
  props: ['data'],
  data() {
    return {
      id: '',
      detailData: {},
      imageList: [],
      audioList: [],
      videoList: [],
      docList: [],
      fileList: [],
    }
  },
  mounted() {
    this.setId(this.data.id)
  },
  created() {},
  methods: {
    setId(id) {
      this.id = id
      this.fetchDetailData(this.id)
    },
    onClose() {
      this.id = ''
      this.detailData = {}
      this.imageList = []
      this.audioList = []
      this.videoList = []
      this.docList = []
      this.fileList = []
    },
    /**
     * @description: 任务详情数据
     * @event:
     * @param {*} id 任务id
     * @return {*}
     */
    fetchDetailData(id) {
      api.screen.wgyWtInfoUsingGet({ id: id }).then((res) => {
        if (res.code == 200) {
          this.detailData = res.data
          // 初始化图表数据
          if (this.detailData.monitorDataDto) {
            let standValues
            if (
              this.detailData.monitorDataDto.standValues &&
              this.detailData.monitorDataDto.standValues[0]
            ) {
              standValues = parseFloat(this.detailData.monitorDataDto.standValues[0])
            }
            this.$refs.sjChart.drawChartData(
              this.detailData.monitorDataDto.dataList || [],
              standValues
            )
          }
          // 初始化地图数据
          // if (this.detailData.latitude) {
          // } else {
          //   this.$refs.hzmap.setIcon([]);
          // }
          // 初始化附件数据
          if (this.detailData.fileList != null) {
            this.detailData.fileList.map((file) => {
              switch (file.fileType) {
                case 'image': {
                  this.imageList.push(file)
                  break
                }
                case 'video': {
                  this.videoList.push(file)
                  break
                }
                case 'audio': {
                  this.audioList.push(file)
                  break
                }
                case 'doc': {
                  this.docList.push(file)
                  break
                }
                default: {
                  console.log('default')
                }
              }
              return file
            })
          }
          // 初始化工作流数据
          if (this.detailData.workflowRecordTree) {
            this.$refs.workFlow.setWorkFlow(this.detailData.workflowRecordTree)
          }
        }
      })
    },
    fresh() {
      this.fetchDetailData(this.id)
    },
  },
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: block;
  width: 4px !important;
  background-color: #0088bf;
}
::-webkit-scrollbar-thumb {
  background-color: #cccccc6b;
  border-radius: 2px;
}
.problem-details {
  max-height: 840px;
  overflow-y: auto;
  overflow-x: hidden;
}
.drawer-detail {
  overflow: hidden;
  overflow-y: scroll;
}
.detail-container {
  width: 60rem;
  :deep(.n-image) {
    img {
      max-width: 100%;
    }
  }
  .detail-item {
    // height: 3rem;
    padding: 0.5rem 0;
    width: 100%;
    margin: 2rem 0;
    letter-spacing: 1px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-2 {
    flex: 2;
  }
}
.img-item {
  max-width: 20rem;
  max-height: 15rem;
  margin: 10px 10px;
}
.btn-list {
  text-align: right;
}
.ivu-upload-list {
  display: flex;
  flex-wrap: wrap;
  .ivu-upload-list-file {
    width: 200px !important;
  }
}
</style>
